import { createAction } from '@reduxjs/toolkit';

export const showLoader = createAction('[app] show loader');
export const hideLoader = createAction('[app] hide loader');
